import * as styles from "./css/FiringMode.module.css";
import { Text } from "@gui/components";
const FiringMode = props => {
    return (<li class={`${styles.firing_type}${props.selected ? ` ${styles.selected}` : ``}`}>
            <Text>{props.title}</Text>
        </li>);
};
export { FiringMode };
